import { Injectable } from '@angular/core';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelPowersupplyListService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string) {
    const workbook = new Excel.Workbook;
    workbook.addWorksheet('PowerSupplyList');
    const sheet = workbook.getWorksheet(1);
    sheet.columns = this.getHeaders();
    sheet.addRows(json);
    sheet.eachRow(function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell) {
        if (rowNumber === 1) {
          sheet.getCell(cell.address.toString()).fill = {
            type: 'gradient', gradient: 'angle', degree: 0, stops: [
              { position: 0, color: { argb: 'd9f1fa' } },
              { position: 0.5, color: { argb: 'd9f1fa' } },
              { position: 1, color: { argb: 'd9f1fa' } }
            ]
          };
          sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
          sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8, bold: 'true' };
        } else {
          sheet.getCell(cell.address.toString()).alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          sheet.getCell(cell.address.toString()).font = { name: 'Calibri', family: 2, size: 8 };
          sheet.getCell(cell.address.toString()).border = { right: { style: 'thin' }, top: { style: 'thin' }, bottom: { style: 'thin' }, left: { style: 'thin' } };
        }
      });
    });
    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: EXCEL_TYPE });
      FileSaver.saveAs(blob, excelFileName + EXCEL_EXTENSION);
    })
    return false;
  }

  getHeaders() {
    let wchPowerSupplyName = 25;
    let wchMacAddress = 15;
    let wchNodeName = 9;
    let wchRegionName = 17;
    let wchApiResults = 65;
    let wchlat = 10;
    let wchlong = 10;
    let wchpsID = 10;
    let wchHouseNumber = 16;
    let wchPowerSupplyAddress = 16;
    let wchState = 7;
    let wchZip = 7;
    let wchNode2 = 9;
    let wchNode3 = 9;
    let wchNode4 = 9;
    let wchNode5 = 9;
    let wchNode6 = 9;
    let wchNode7 = 9;
    let wchNode8= 9;
    let wchNode9= 9;
    let wchNode10= 9;
    let wchNode11= 9;
    let wchNode12= 9;
    let wchNode13= 9;
    let wchNode14= 9;
    let wchNode15= 9;
    let wchNode16= 9;
    let wchNode17= 9;
    let wchNode18= 9;
    let wchNode19= 9;
    let wchNode20= 9;
    let wchNode21= 9;
    let wchNode22= 9;
    let wchNode23= 9;
    let wchNode24= 9;
    let wchNode25= 9;
    let wchNode26= 9;
    let wchNode27= 9;
    let wchNode28= 9;
    let wchNode29= 9;
    let wchNode30= 9;
    let wchNode31= 9;
    let wchNode32= 9;


    return [
      { header: 'PowerSupplyName', key: 'powerSupplyName', width: wchPowerSupplyName },
      { header: 'MacAddress', key: 'macAddress', width: wchMacAddress },
      { header: 'Node', key: 'nodeName', width: wchNodeName },
      { header: 'Region Name', key: 'edfa', width: wchRegionName },
      { header: 'PS Last Saved', key: 'apiResults', width: wchApiResults },
      { header: 'Latitude', key: 'gpsLatitude', width: wchlat },
      { header: 'Longitude', key: 'gpsLongitude', width: wchlong },
      { header: 'PS ID', key: 'powerSupplyId', width: wchpsID },
      { header: 'HouseNumber', key: 'houseNumber', width: wchHouseNumber },
      { header: 'Address', key: 'powerSupplyAddress', width: wchPowerSupplyAddress },
      { header: 'State', key: 'state', width: wchState },
      { header: 'Zip', key: 'zip', width: wchZip },
      { header: 'Node2', key: 'node2', width: wchNode2 },
      { header: 'Node3', key: 'node3', width: wchNode3 },
      { header: 'Node4', key: 'node4', width: wchNode4 },
      { header: 'Node5', key: 'node5', width: wchNode5 },
      { header: 'Node6', key: 'node6', width: wchNode6 },
      { header: 'Node7', key: 'node7', width: wchNode7 },
      { header: 'Node8', key: 'node8', width: wchNode8 },
      { header: 'Node9', key: 'node9', width: wchNode9 },
      { header: 'Node10', key: 'node10', width: wchNode10 },
      { header: 'Node11', key: 'node11', width: wchNode11 },
      { header: 'Node12', key: 'node12', width: wchNode12 },
      { header: 'Node13', key: 'node13', width: wchNode13 },
      { header: 'Node14', key: 'node14', width: wchNode14 },
      { header: 'Node15', key: 'node15', width: wchNode15 },
      { header: 'Node16', key: 'node16', width: wchNode16 },
      { header: 'Node17', key: 'node17', width: wchNode17 },
      { header: 'Node18', key: 'node18', width: wchNode18 },
      { header: 'Node19', key: 'node19', width: wchNode19 },
      { header: 'Node20', key: 'node20', width: wchNode20 },
      { header: 'Node21', key: 'node21', width: wchNode21 },
      { header: 'Node22', key: 'node22', width: wchNode22 },
      { header: 'Node23', key: 'node23', width: wchNode23 },
      { header: 'Node24', key: 'node24', width: wchNode24 },
      { header: 'Node25', key: 'node25', width: wchNode25 },
      { header: 'Node26', key: 'node26', width: wchNode26 },
      { header: 'Node27', key: 'node27', width: wchNode27 },
      { header: 'Node28', key: 'node28', width: wchNode28 },
      { header: 'Node29', key: 'node29', width: wchNode29 },
      { header: 'Node30', key: 'node30', width: wchNode30 },
      { header: 'Node31', key: 'node31', width: wchNode31 },
      { header: 'Node32', key: 'node32', width: wchNode32 },
    ];
  }
}
